export const LEVELS = {
  urgent: { label: "Urgent", color: "#EF4444", bg: "rgba(239,68,68,0.14)" },
  faire: { label: "À faire", color: "#F59E0B", bg: "rgba(245,158,11,0.14)" },
  prevoir: { label: "À prévoir", color: "#06B6D4", bg: "rgba(6,182,212,0.14)" },
  savoir: { label: "À savoir", color: "#10B981", bg: "rgba(16,185,129,0.14)" },
};

export function LevelBadge({ level, testid }) {
  const l = LEVELS[level] || LEVELS.savoir;
  return (
    <span data-testid={testid} className="text-xs font-medium px-2.5 py-1 rounded-full"
      style={{ color: l.color, background: l.bg }}>
      {l.label}
    </span>
  );
}

export function daysLabel(days) {
  if (days == null) return "—";
  if (days < 0) return `en retard de ${Math.abs(days)} j`;
  if (days === 0) return "aujourd'hui";
  return `dans ${days} j`;
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("fr-FR", { day: "2-digit", month: "short", year: "numeric" });
  } catch { return iso; }
}

export function brandLogo(brand) {
  if (!brand) return null;
  const slug = String(brand).toLowerCase().replace(/[^a-z0-9]/g, "");
  if (!slug) return null;
  return `https://www.google.com/s2/favicons?domain=${slug}.com&sz=128`;
}

export const CATEGORY_LABELS = {
  product: "Produit", equipment: "Équipement", vehicle: "Véhicule",
  property: "Logement", insurance: "Assurance", contract: "Contrat", health: "Santé",
};
